import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { GuestGuard, ResourceDetailsViewGuard } from '@klickdata/core/auth';
import { GuestActivateGuard } from '@klickdata/core/auth/src/auth/guest-activate-guard.service';
import { GuestStartGuard } from '@klickdata/core/auth/src/auth/guest-start-guard.service';
import { ResourceDetailsComponent } from '@klickdata/shared-components/src/resource-details/resource-details.component';
import { MainResultsComponent } from '@klickdata/shared-components/src/search/main-results/main-results.component';
import { ActivateComponent } from './activate/activate.component';
import { ChatIoPaymentComponent } from './chat-io/chat-io-payment/chat-io-payment.component';
import { ForgetPasswordComponent } from './forget-password/forget-password.component';
import { GuestComponent } from './guest.component';
import { LoginComponent } from './login/login.component';
import { OnBoardingComponent } from './on-boarding/on-boarding.component';
import { ResetPasswordComponent } from './reset-password/reset-password.component';
import { SignupComponent } from './signup/signup.component';
import { TrialComponent } from './trial/trial.component';
import { OnboardingGuestModeComponent } from './onboarding-guest-mode/onboarding-guest-mode.component';

const routes: Routes = [
    {
        path: '',
        component: GuestComponent,
        canActivate: [],
        children: [
            { path: '', redirectTo: 'start', pathMatch: 'full' },
            { path: 'search', component: MainResultsComponent },
            { path: 'resource/:id', component: ResourceDetailsComponent, canActivate: [ResourceDetailsViewGuard] },
            {
                path: 'resource-details/:id',
                component: ResourceDetailsComponent,
                canActivate: [ResourceDetailsViewGuard],
            },

            // { path: 'start', component: StartComponent, canActivate: [GuestStartGuard] },
            {
                path: 'start',
                component: OnBoardingComponent,
                canActivate: [GuestStartGuard],
                children: [{ path: 'search', component: MainResultsComponent }],
            },
            { path: 'login', component: LoginComponent, canActivate: [GuestGuard] },
            {
                path: 'guest-landing',
                component: OnboardingGuestModeComponent,
                canActivate: [GuestGuard],
                children: [{ path: 'search', component: MainResultsComponent }],
            },
            { path: 'signup', component: SignupComponent, canActivate: [GuestGuard] },
            { path: 'trial', component: TrialComponent, canActivate: [GuestGuard] },
            { path: 'activate/:token', component: ActivateComponent, canActivate: [GuestActivateGuard] },
            { path: 'password/forget', component: ForgetPasswordComponent, canActivate: [GuestActivateGuard] },
            { path: 'password/reset/:token', component: ResetPasswordComponent, canActivate: [GuestActivateGuard] },
            { path: 'payment', component: ChatIoPaymentComponent },
        ],
    },
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule],
})
export class GuestRoutingModule {}
